module.exports = __webpack_public_path__ + "img/badge_documentazione.46823da6.jpg";